<template>
  <!-- Person might join before && thus never get hasJoinedDuringSession marked, as only hasJoinedBeforeSession was marked -->
  <div v-if="hasJoinedDuringSession" class="message">
    {{ hasJoinedMessage }}
  </div>
  <!-- Until Redis & more real time solutions for check if user in session,
    using dumb version -->

  <!-- <div v-if="isCurrentlyInSession" class="message">
      {{ `Session ends in ${timeLeft} minutes. Are you being productive?` }}
    </div>
    <div v-else class="message">
      {{ `Please get back in the session! Ends in ${timeLeft} minutes.` }}
    </div> -->
  <div v-else class="message">
    {{ hasNotJoinedMessage }}
  </div>
</template>

<script>
export default {
  name: "TimerOngoingMessage",
  props: ["hasJoinedDuringSession", "sessionIsMatched", "partnerName", "timeLeft", "isLate"],
  computed: {
    hasJoinedMessage() {
      if (this.$windowWidth >= 1180) {
        return `Session ends in ${this.timeLeft} minutes. Are you being productive?`;
      } else if (this.$windowWidth >= 995) {
        return `${this.timeLeft} minutes left in the session.`;
      } else {
        return ``;
      }
    },
    hasNotJoinedMessage() {
      if (this.isLate) {
        if (this.$windowWidth >= 1180) {
          return `You're late! Please join the session. ${this.timeLeft} minutes left.`;
        } else if (this.$windowWidth >= 995) {
          return `You're late! ${this.timeLeft} minutes left.`;
        } else {
          return `You're late, please join!`;
        }
      } else {
        if (this.$windowWidth >= 1180) {
          return `The session has started. Please join! Ends in ${this.timeLeft} minutes.`;
        } else if (this.$windowWidth >= 995) {
          return `The session started. ${this.timeLeft} minutes left.`;
        } else {
          return `The session has started.`;
        }
      }
    },
  },
};
</script>
